import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default, { useState, useRef, useEffect, useContext } from 'react';
import { useKeyPress } from '../../../hooks/useKeyPress/useKeyPress.js';
import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import 'fromentries';
import ReactDOM__default from 'react-dom';
import clsx from 'clsx';
import '../../Atoms/Button/Button.js';
import '../../Atoms/Checkbox/Checkbox.js';
import '../../Atoms/Text/Text.js';
import '../../Atoms/Device/DeviceProvider.js';
import '../../Atoms/EmployeeBadge/EmployeeBadge.js';
import '../../Atoms/FeatureFlag/FeatureFlag.js';
import '../../Atoms/Icon/generated/IconAdd.js';
import '../../Atoms/Icon/generated/IconAddFilled.js';
import '../../Atoms/Icon/generated/IconAddOutline.js';
import '../../Atoms/Icon/generated/IconAddUser.js';
import '../../Atoms/Icon/generated/IconAddressBook.js';
import '../../Atoms/Icon/generated/IconAllTreatments.js';
import '../../Atoms/Icon/generated/IconArrowBack.js';
import '../../Atoms/Icon/generated/IconArrowForward.js';
import '../../Atoms/Icon/generated/IconBadgeCheck.js';
import '../../Atoms/Icon/generated/IconBeard.js';
import '../../Atoms/Icon/generated/IconBody.js';
import '../../Atoms/Icon/generated/IconCake.js';
import '../../Atoms/Icon/generated/IconCalendar.js';
import '../../Atoms/Icon/generated/IconCalendarAdd.js';
import '../../Atoms/Icon/generated/IconCalendarDelete.js';
import '../../Atoms/Icon/generated/IconCard.js';
import '../../Atoms/Icon/generated/IconCash.js';
import '../../Atoms/Icon/generated/IconCaution.js';
import '../../Atoms/Icon/generated/IconChat.js';
import '../../Atoms/Icon/generated/IconCheckFilled.js';
import '../../Atoms/Icon/generated/IconCheckOutline.js';
import '../../Atoms/Icon/generated/IconChecked.js';
import '../../Atoms/Icon/generated/IconChevronDown.js';
import '../../Atoms/Icon/generated/IconChevronLeft.js';
import '../../Atoms/Icon/generated/IconChevronLeftOutline.js';
import '../../Atoms/Icon/generated/IconChevronRight.js';
import '../../Atoms/Icon/generated/IconChevronRightOutline.js';
import '../../Atoms/Icon/generated/IconChevronUp.js';
import { IconClose } from '../../Atoms/Icon/generated/IconClose.js';
import '../../Atoms/Icon/generated/IconCloseOutline.js';
import '../../Atoms/Icon/generated/IconComment.js';
import '../../Atoms/Icon/generated/IconCompass.js';
import '../../Atoms/Icon/generated/IconConfirmOrDeny.js';
import '../../Atoms/Icon/generated/IconCopy.js';
import '../../Atoms/Icon/generated/IconDiscountFilled.js';
import '../../Atoms/Icon/generated/IconDiscountOutline.js';
import '../../Atoms/Icon/generated/IconEdit.js';
import '../../Atoms/Icon/generated/IconEmail.js';
import '../../Atoms/Icon/generated/IconExpand.js';
import '../../Atoms/Icon/generated/IconExternal.js';
import '../../Atoms/Icon/generated/IconFace.js';
import '../../Atoms/Icon/generated/IconFilter.js';
import '../../Atoms/Icon/generated/IconGift.js';
import '../../Atoms/Icon/generated/IconHair.js';
import '../../Atoms/Icon/generated/IconHairRemoval.js';
import '../../Atoms/Icon/generated/IconHappy.js';
import '../../Atoms/Icon/generated/IconHeartFilled.js';
import '../../Atoms/Icon/generated/IconHeartOutlined.js';
import '../../Atoms/Icon/generated/IconHelp.js';
import '../../Atoms/Icon/generated/IconHide.js';
import '../../Atoms/Icon/generated/IconHighlights.js';
import '../../Atoms/Icon/generated/IconHome.js';
import '../../Atoms/Icon/generated/IconHomebasedVenue.js';
import '../../Atoms/Icon/generated/IconImage.js';
import '../../Atoms/Icon/generated/IconInfoOutline.js';
import '../../Atoms/Icon/generated/IconLegal.js';
import '../../Atoms/Icon/generated/IconLocation.js';
import '../../Atoms/Icon/generated/IconLock.js';
import '../../Atoms/Icon/generated/IconLogOut.js';
import '../../Atoms/Icon/generated/IconMale.js';
import '../../Atoms/Icon/generated/IconMassage.js';
import '../../Atoms/Icon/generated/IconMedicalDental.js';
import '../../Atoms/Icon/generated/IconMinusOutline.js';
import '../../Atoms/Icon/generated/IconMobileVenue.js';
import '../../Atoms/Icon/generated/IconMoney.js';
import '../../Atoms/Icon/generated/IconNails.js';
import '../../Atoms/Icon/generated/IconNewVenue.js';
import '../../Atoms/Icon/generated/IconNotes.js';
import '../../Atoms/Icon/generated/IconOnMap.js';
import '../../Atoms/Icon/generated/IconOptions.js';
import '../../Atoms/Icon/generated/IconPhone.js';
import '../../Atoms/Icon/generated/IconPin.js';
import '../../Atoms/Icon/generated/IconPinOutline.js';
import '../../Atoms/Icon/generated/IconPresentBox.js';
import '../../Atoms/Icon/generated/IconProfile.js';
import '../../Atoms/Icon/generated/IconReceipt.js';
import '../../Atoms/Icon/generated/IconSearch.js';
import '../../Atoms/Icon/generated/IconSecure.js';
import '../../Atoms/Icon/generated/IconSettings.js';
import '../../Atoms/Icon/generated/IconSort.js';
import '../../Atoms/Icon/generated/IconSpa.js';
import '../../Atoms/Icon/generated/IconStarFilled.js';
import '../../Atoms/Icon/generated/IconStarOutline.js';
import '../../Atoms/Icon/generated/IconSupport.js';
import '../../Atoms/Icon/generated/IconTeam.js';
import '../../Atoms/Icon/generated/IconTime.js';
import '../../Atoms/Icon/generated/IconTreatwellLogo.js';
import '../../Atoms/Icon/generated/IconUnisex.js';
import '../../Atoms/Icon/generated/IconUser.js';
import '../../Atoms/Icon/generated/IconUserDetails.js';
import '../../Atoms/Icon/generated/IconVenue.js';
import '../../Atoms/Icon/generated/IconView.js';
import '../../Atoms/Icon/generated/IconVoucher.js';
import '../../Atoms/Icon/generated/IconWallet.js';
import '../../Atoms/Icon/generated/IconWarningFilled.js';
import '../../Atoms/Icon/generated/IconWarningOutline.js';
import '../../Atoms/Icon/generated/IconWebsite.js';
import '../../Atoms/IconBadge/IconBadge.js';
import '../../Atoms/Input/Input.js';
import '../../Layout/Box/Box.js';
import { Inline } from '../../Layout/Inline/Inline.js';
import '../../Layout/Stack/Stack.js';
import '../../Atoms/Radio/Radio.js';
import '@treatwell/design-tokens';
import { VisuallyHidden } from '../../Atoms/VisuallyHidden/VisuallyHidden.js';
import '../../Atoms/Textarea/Textarea.js';
import '../../Atoms/TreatmentTypeBadge/TreatmentTypeBadge.js';
import '../../Atoms/Viewport/useViewport.js';
import '../../Atoms/LinkButton/LinkButton.js';
import { useDocumentBodyScrollLock } from './useDocumentBodyScrollLock.js';
import { useDetectModalBodyScroll } from './useDetectModalBodyScroll.js';
import { ModalContext } from './ModalContext.js';
import styles from './Modal.module.css.js';

const Modal = ({ isOpen, title, children, preventDismiss, onClose, 'data-cy': dataCy, style, className, }) => {
    const [isBodyScrolled, setIsBodyScrolled] = useState(false);
    const modalRef = useRef(null);
    const isEscapeKeyPressed = useKeyPress({
        key: 'Escape',
    });
    useEffect(() => {
        if (isEscapeKeyPressed && isOpen && !preventDismiss) {
            onClose();
        }
    }, [isEscapeKeyPressed, isOpen, preventDismiss]);
    useKeyPress({
        key: 'Tab',
        onPress: (evt, type) => {
            if (type === 'KEYDOWN') {
                onKeyboardNavigation(evt);
            }
        },
    });
    const getFocusableElements = () => {
        var _a;
        return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    };
    const onKeyboardNavigation = (evt) => {
        if (!modalRef.current) {
            return;
        }
        const focusableElements = getFocusableElements();
        if (!focusableElements || focusableElements.length === 0) {
            return;
        }
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (evt.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            return evt.preventDefault();
        }
        if (!evt.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            return evt.preventDefault();
        }
        if (firstElement === lastElement) {
            firstElement.focus();
            return evt.preventDefault();
        }
        if (!modalRef.current.contains(document.activeElement)) {
            firstElement.focus();
        }
    };
    const onClickOutside = (evt) => {
        var _a;
        if ((modalRef && ((_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.contains(evt.target))) ||
            preventDismiss) {
            return;
        }
        onClose();
    };
    if (!isOpen) {
        return null;
    }
    return ReactDOM__default.createPortal(jsxRuntimeExports.jsx("div", { className: clsx(styles.container, className), role: "dialog", "aria-modal": "true", "aria-label": title, "aria-labelledby": "modalTitle", "aria-describedby": "modalBody", onClick: onClickOutside, "data-cy": dataCy, children: jsxRuntimeExports.jsx("div", { ref: modalRef, className: styles.content, style: style, children: jsxRuntimeExports.jsx(ModalContext.Provider, { value: { title, onClose, isBodyScrolled, setIsBodyScrolled }, children: children }) }) }), document.body);
};
const CloseButton = ({ closeLabel, inHeader }) => {
    const { onClose } = useContext(ModalContext);
    return (jsxRuntimeExports.jsxs("button", { className: clsx(styles.closeButton, {
            [styles.inHeader]: inHeader,
        }), onClick: onClose, "data-cy": "ModalClose", children: [jsxRuntimeExports.jsx(VisuallyHidden, { children: closeLabel }), jsxRuntimeExports.jsx(IconClose, { className: styles.closeIcon, size: 24 })] }));
};
const Header = ({ closeLabel, hidden, children }) => {
    const { isBodyScrolled } = useContext(ModalContext);
    const content = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [children ? (React__default.cloneElement(children, {
                id: 'modalTitle',
            })) : (jsxRuntimeExports.jsx("span", {})), jsxRuntimeExports.jsx(CloseButton, { closeLabel: closeLabel, inHeader: true })] }));
    return hidden ? (jsxRuntimeExports.jsx("div", { className: styles.headerHidden, children: jsxRuntimeExports.jsx(VisuallyHidden, { children: content }) })) : (jsxRuntimeExports.jsx(Inline, { justify: "between", align: "center", className: clsx(styles.header, {
            [styles.headerShadow]: isBodyScrolled,
        }), children: content }));
};
const Body = ({ children }) => {
    const modalBodyRef = useRef(null);
    useDocumentBodyScrollLock({ ref: modalBodyRef });
    useDetectModalBodyScroll(modalBodyRef);
    return (jsxRuntimeExports.jsx("div", { ref: modalBodyRef, className: styles.body, id: "modalBody", children: children }));
};
const Footer = ({ children }) => {
    return jsxRuntimeExports.jsx("div", { className: styles.footer, children: children });
};
Header.displayName = 'Modal.Header';
Body.displayName = 'Modal.Body';
Footer.displayName = 'Modal.Footer';
Modal.displayName = 'Modal';
CloseButton.displayName = 'CloseButton';
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.CloseButton = CloseButton;

export { Modal };
//# sourceMappingURL=Modal.js.map
